module.exports = __webpack_public_path__ + "static/media/44494127_2199891036752742_3704317865831170048_o-thumb.c4813cdd.jpg";